import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { api } from '../../../auth'
import { searchKb } from '../api/knowledgeBaseApi'
import type { KbSearchResult } from '../types'
import SearchResults from '../components/SearchResults'
import KBSkeleton from '../components/KBSkeleton'

interface SearchPageProps {
    onBack: () => void
    onSelectArticle: (slug: string) => void
}

const SearchPage = ({ onBack, onSelectArticle }: SearchPageProps) => {
    const [searchParams] = useSearchParams()
    const query = searchParams.get('q') || ''
    const axiosPrivate = api
    const [results, setResults] = useState<KbSearchResult[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!query.trim()) {
            setResults([])
            setLoading(false)
            return
        }
        let cancelled = false
        setLoading(true)
        searchKb(axiosPrivate, query)
            .then((res) => {
                if (!cancelled) setResults(res)
            })
            .catch(() => {})
            .finally(() => {
                if (!cancelled) setLoading(false)
            })
        return () => {
            cancelled = true
        }
    }, [axiosPrivate, query])

    if (loading) {
        return (
            <div className="kb-container">
                <KBSkeleton variant="search" />
            </div>
        )
    }

    return (
        <div className="kb-container">
            <SearchResults
                query={query}
                results={results}
                onBack={onBack}
                onSelectArticle={onSelectArticle}
            />
        </div>
    )
}

export default SearchPage
